import type { SparklineRange } from '@/components/portfolio/referrals/earnings-sparkline';

export function chartRangeToApiParams(range: SparklineRange): { interval: string; from?: string } {
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  switch (range) {
    case '7d': {
      const from = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
      return { interval: '1d', from: from.toISOString() };
    }
    case '30d': {
      const from = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
      return { interval: '1d', from: from.toISOString() };
    }
    case '90d': {
      const from = new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000);
      return { interval: '1w', from: from.toISOString() };
    }
    case 'all':
      return { interval: '1m' };
  }
}
